// extracted by mini-css-extract-plugin
module.exports = {"root":"BidMaintenancePage_root__1xiWt","dialog":"BidMaintenancePage_dialog__2Waub","submitButton":"BidMaintenancePage_submitButton__2sV_P"};